import { defineComponent, ref, computed, watch, getCurrentInstance } from "vue";
export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        id: {
            type: Number,
            default: 0
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var schemaForm = ref();
        var model = ref({
            name: ""
        });
        var formConfig = ref({});
        var schema = computed(function() {
            return {
                type: "object",
                properties: {
                    name: {
                        label: root.$t("playTurbo.authAccount.addAssistAccountDialog.inputName"),
                        component: "input",
                        class: "edit-project-name",
                        field: {
                            size: "mini"
                        }
                    }
                }
            };
        });
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        var handleClose = function() {
            if (!props.loading) {
                emit("update:visible", false);
            }
        };
        var handleSubmit = function() {
            emit("submit", model.value["name"]);
        // handleClose()
        };
        watch(function() {
            return props.visible;
        }, function(val) {
            if (val) {
                model.value = {
                    name: ""
                };
            }
        }, {
            immediate: true
        });
        return {
            dialogVisible: dialogVisible,
            model: model,
            schema: schema,
            formConfig: formConfig,
            schemaForm: schemaForm,
            handleClose: handleClose,
            handleSubmit: handleSubmit
        };
    }
});
